export default __webpack_public_path__ + "static/media/avatar-s-6.06055061.jpg";